import { render, staticRenderFns } from "./DashboardWidgetList.vue?vue&type=template&id=1bc11a67&scoped=true&"
import script from "./DashboardWidgetList.vue?vue&type=script&lang=ts&"
export * from "./DashboardWidgetList.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardWidgetList.vue?vue&type=style&index=0&id=1bc11a67&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc11a67",
  null
  
)

export default component.exports